import { Paper, Button, Tooltip, Typography, Grid, Box } from '@mui/material';
import { Restore as RestoreIcon, AttachFile as AttachFileIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { CashTxnList, NonCashTxnList } from './';
import moment from 'moment';
import { dateMonthYearDateFormat } from '../../../../constants';
import { PermissionWrapper } from '../../../../wrappers';
import { useState } from 'react';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import { trackActivity } from '../../../../utils/mixpanel';
import UploadingIcon from '../../../../shared_elements/components/UploadingIcon';
import NumericLabel from 'react-pretty-numbers';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AuditPopover from '../../../../shared_elements/components/popover';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PostAddIcon from '@mui/icons-material/PostAdd';
import { globalGetService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { useSnackbar } from 'notistack';
import { getSdInvoiceApi } from '../apiService';
import { useParams } from 'react-router';
import { getStorage } from '../../../../shared_elements/actionCreators';
import { useDispatch } from 'react-redux';
import AddSecurityDepositInv from '../../../invoices/components/AddSecurityDepositInv';
import { PageLoader } from '../../../../shared_elements';
import SecurityDepositInvoiceListModal from './SecurityDepositInvoiceListModal';

function SecurityDepositListing({ uploadedFileData, setUploadFileStatus, slug, uploadFileProgressData, viewFileStatus, item, index, onViewFn, onEditFn, viewRevisonHistory, onDeleteFn, onTxnFn, bulk, toggleBulkOps, setBulk, onDeleteTxn, sdcData, onOpenAttachments, onTxnFnAttachments, sortInfo, createSortHandler, cashTxnSorting, }) {
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [securityDepositInvoice, setSecurityDepositInvoice] = useState({});
    const [sdInvModal, setSdInvModal] = useState({ modal: false, data: null })
    const [invoiceListModal, setInvoiceListModal] = useState({ modal: false, data: null })
    const [isLoading, setLoading] = useState(false)
    const { enqueueSnackbar } = useSnackbar();
    const params= useParams();
    const dispatch=useDispatch();
    
    const getSecurityDepositInvoice = () => {
            setLoading(true)
            globalGetService(getSdInvoiceApi(item?.id))
                .then(response => {
                    if (checkApiStatus(response)) {
                        setSecurityDepositInvoice(response.data.data);
                        setLoading(false)
                        setSdInvModal({ modal: true, data: { ...item, invoice_type: { label: 'Security Deposit', value: 6 } } });
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                    } else {
                        setLoading(false)
                        setSecurityDepositInvoice(response.data.data);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
                    }
                })
                  dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"invoices"}));
        }

        const toggleInvModel = () => {
        setSdInvModal({ modal: false, data: null })
    }

    const ViewInvoice = ({ item }) => {

            if (!item?.invoices?.length) return <Typography className='security-deposite-config-data'>--</Typography>;

            const handleClick = () => {
                setInvoiceListModal({ modal: true, data: item.invoices });
                handleItemClicked('View Invoices Button');
            };

            return (
                <Tooltip arrow title="View Invoices">
                    <Button
                        size="small"
                        variant="text"
                        color="primary"
                        sx={{ textTransform: 'none', fontSize: '13px', padding: 0, minWidth: 'auto' }}
                        onClick={handleClick}
                    >
                        View
                    </Button>
                </Tooltip>
            );
        };
    
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Security Deposit Listing`, page_type: page_type, })
    }
    return (
        <section style={{ position: 'sticky', zIndex: 9, top: 0, }} className='security-deposit-listing'>
            <Paper square key={index} elevation={1} sx={{ padding: '2px', background: '#EFEFEF' }}>
                <Box sx={{ overflowX: 'auto' }}>
                <Grid container spacing={1} sx={{ padding: '5px', flexWrap: 'nowrap', minWidth: 'max-content' }}>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <Typography className='security-deposite-config-headings'>Action</Typography>
                        <Box className="table-icon-container">
                            <AuditPopover item={item}>
                                <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                            </AuditPopover>
                            <Tooltip title="Revision History"><RestoreIcon className='revision-history' onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} sx={{ cursor: 'pointer' }} fontSize="small" color="primary" /></Tooltip>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['C'] }}>
                                <Tooltip title={item?.security_deposit_type?.value === 1 ? 'Add TXN' : 'Add Non TXN'}><AddCircleOutlineIcon fontSize="small" color="primary" onClick={() => { onTxnFn(item?.security_deposit_type?.value, 'add'); handleItemClicked(`${item?.security_deposit_type?.value === 1 ? 'Add TXN' : 'Add Non TXN'}Icon`) }} sx={{ fontSize: '18px', cursor: 'pointer' }} /></Tooltip>
                            </PermissionWrapper>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['R'] }}>
                                <Tooltip title="View"><VisibilityIcon sx={{ cursor: 'pointer' }} onClick={() => { onViewFn(); handleItemClicked('ViewIcon') }} fontSize='small' color='primary' /></Tooltip> 
                            </PermissionWrapper>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['U'] }}>
                                <Tooltip title="Edit"><EditIcon sx={{ cursor: 'pointer' }} onClick={() => { onEditFn(); handleItemClicked('EditIcon') }} fontSize='small' color='primary' /></Tooltip> 
                            </PermissionWrapper>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['D'] }}>
                                <Tooltip title="Delete"><DeleteIcon sx={{ cursor: 'pointer' }} onClick={() => { onDeleteFn(); handleItemClicked('DeleteIcon') }} fontSize='small' color='error' /></Tooltip> 
                            </PermissionWrapper>
                             <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['C'] }}>
                            {item?.security_deposit_type?.value === 1 && item?.invoice_exists === false ? <Tooltip title="Add Security Deposite Invoice"><PostAddIcon sx={{ cursor: 'pointer' }} onClick={() => {getSecurityDepositInvoice(); handleItemClicked('Add Security Deposite Invoice Icon') }} fontSize='small' color='primary' /></Tooltip> : null }
                            </PermissionWrapper>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['R'] }}>
                            {
                                item?.attachments?.length > 0 && (
                                    <Tooltip title="Attached File(s)">
                                        <Box className="attachment-container">
                                                <AttachFileIcon fontSize="small" color="primary" onClick={() => { onOpenAttachments(); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                            <Box className="attachment-count">({item?.attachments?.length})</Box>
                                        </Box>
                                    </Tooltip>
                                )
                            }
                            </PermissionWrapper>
                             { (slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 6, md: 2.5 }}>
                        <Typography className='security-deposite-config-headings'>Security Deposit Type</Typography>
                        <Typography className='security-deposite-config-data'>{item?.security_deposit_type?.label || '--'}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 2.5 }}>
                        <Typography className='security-deposite-config-headings'>Security Deposit Against</Typography>
                        <Typography className='security-deposite-config-data'>{item?.security_deposit_against_id?.name || '--'}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 2 }}>
                        <Typography className='security-deposite-config-headings'>Contractual Amount</Typography>
                        {/* <Typography className='security-deposite-config-data'>{item?.contractual_amount ? sdcData?.contractual_currency?.code + " " + sdcData?.contractual_currency?.symbol + "" + item?.contractual_amount : '--'}</Typography> */}
                        <Typography className='security-deposite-config-data'>
                            {item?.contractual_amount != null ? (
                                <NumericLabel
                                    params={{
                                        locales: 'en-GB',
                                        currency: true,
                                        precision: 2,
                                        currencyIndicator: sdcData?.contractual_currency?.code || '',
                                        commafy: true,
                                        justification: "L",
                                    }}
                                >
                                    {Number(item.contractual_amount)}
                                </NumericLabel>
                            ) : (
                                "--"
                            )}
                        </Typography>
                    </Grid>
                    {sdcData?.base_currency && 
                    <Grid size={{ xs: 6, md: 2 }}>
                        <Typography className='security-deposite-config-headings'>Base Amount</Typography>
                        <Typography className='security-deposite-config-data'>
                            {item?.base_amount ? (
                                <NumericLabel
                                    params={{
                                        locales: 'en-GB',
                                        currency: true,
                                        precision: 2,
                                        currencyIndicator: item?.currency?.code || sdcData?.base_currency?.code || '',
                                        commafy: true,
                                        justification: "L",
                                    }}
                                >
                                    {Number(item.base_amount)}
                                </NumericLabel>
                            ) : (
                                "--"
                            )}
                        </Typography>
                    </Grid>}
                    <Grid size={{ xs: 6, md: 2 }}>
                        <Typography className='security-deposite-config-headings'>Due Date</Typography>
                        <Typography className='security-deposite-config-data'>{item?.due_date ? moment(item.due_date).format(dateMonthYearDateFormat) : '--'}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 2 }}>
                        <Typography className='security-deposite-config-headings'>Invoice Number</Typography>
                        <Typography className='security-deposite-config-data'>{<ViewInvoice item={item}/>}</Typography>
                    </Grid>
                </Grid>
                </Box>
            </Paper>
            <Grid container sx={{ padding: '6px 10px', border: '1px solid #D7D7D7' }}>
                <Grid size={{ xs: 12, md: 12 }} sx={{ textAlign: 'right' }}>
                    <ul className='list-inline'>
                        {
                            bulk?.type && bulk?.ids?.length && bulk?.ids[0]?.security_deposit_slug === item?.slug ?
                                <>
                                    <li>
                                        <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '', securitySlug: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                    </li>
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['D'] }}>
                                    <li style={{ marginInline: '5px' }}>
                                            <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true, securitySlug: item?.slug }); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.length})`}</Button>
                                    </li>
                                    </PermissionWrapper>
                                </> : null
                        }
                    </ul>
                </Grid>
            </Grid>
            {item?.security_deposit_type?.value === 1 &&
                <CashTxnList
                    txnslug={slug}
                    uploadedFileData={uploadedFileData }
                    uploadFileProgressData={uploadFileProgressData}
                    viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                    sortInfo={sortInfo}
                    createSortHandler={createSortHandler}
                    onDeleteTxn={onDeleteTxn}
                    bulk={bulk}
                    toggleBulkOps={toggleBulkOps}
                    item={item}
                    sdcData={sdcData}
                    cashTxnSorting={cashTxnSorting}
                    viewRevisonHistory={(transactionsItem) => setRevisionHistory({ modal: true, data: transactionsItem, mode: 'view' })}
                    onView={(txnData) => onTxnFn(item?.security_deposit_type?.value, 'view', txnData)}
                    onEditFn={(txnData) => onTxnFn(item?.security_deposit_type?.value, 'edit', txnData)}
                    onDeleteFn={() => onTxnFn(item?.security_deposit_type?.value, 'add')}
                    onOpenAttachments={(txnData, txnType) => onTxnFnAttachments(txnData, txnType)}
                />}
            {item?.security_deposit_type?.value === 2 &&
                <NonCashTxnList
                    txnslug={slug}
                    uploadedFileData={uploadedFileData }
                    uploadFileProgressData={uploadFileProgressData}
                    viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                    sortInfo={sortInfo}
                    createSortHandler={createSortHandler}
                    onDeleteTxn={onDeleteTxn}
                    bulk={bulk}
                    toggleBulkOps={toggleBulkOps}
                    item={item}
                    sdcData={sdcData}
                    cashTxnSorting={cashTxnSorting}
                    viewRevisonHistory={(transactionsItem) => setRevisionHistory({ modal: true, data: transactionsItem, mode: 'view' })}
                    onView={(txnData) => onTxnFn(item?.security_deposit_type?.value, 'view', txnData)}
                    onEditFn={(txnData) => onTxnFn(item?.security_deposit_type?.value, 'edit', txnData)}
                    onDeleteFn={() => onTxnFn(item?.security_deposit_type?.value, 'add')}
                    onOpenAttachments={(txnData, txnType) => onTxnFnAttachments(txnData, txnType)}
                />}
                {
                revisionHistory.modal &&  
                 <RevisionHistory 
                  moduleName={"security_deposit_transaction"}
                  revisionHistory={revisionHistory}
                  onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                 />
               }
               {sdInvModal?.modal && <AddSecurityDepositInv item={item} securityDepositInvoice={securityDepositInvoice} setSecurityDepositInvoice={setSecurityDepositInvoice} toggleInvModel={toggleInvModel} />}
               {invoiceListModal?.modal &&
                <SecurityDepositInvoiceListModal
                    open={invoiceListModal.modal}
                    invoices={invoiceListModal.data}
                    onClose={() => setInvoiceListModal({ modal: false, data: null })}
                />}
               {isLoading ? <PageLoader /> : null}
        </section>
    )
}

export default SecurityDepositListing